module.exports = __webpack_public_path__ + "assets/img/discover.cb8db5a2.svg";